import { Rocket, Star } from "lucide-react";
import { Badge } from "./badge";

type StatusBadgeType = "featured" | "boosted";

interface StatusBadgeProps {
  type: StatusBadgeType;
  size?: "small" | "medium" | "large";
  showText?: boolean;
}

export function StatusBadge({
  type,
  size = "medium",
  showText = true,
}: StatusBadgeProps) {
  // Size-based classes
  const sizeClasses = {
    small: {
      badge: "px-1.5 py-0.5 text-[10px]",
      icon: "h-3 w-3",
    },
    medium: {
      badge: "px-2 py-1 text-xs",
      icon: "h-4 w-4",
    },
    large: {
      badge: "px-3 py-1.5 text-sm",
      icon: "h-5 w-5",
    },
  };

  // Type-based classes and content
  const typeProps = {
    featured: {
      bg: "bg-amber-500 hover:bg-amber-600",
      icon: (
        <Star className={`fill-white text-white ${sizeClasses[size].icon}`} />
      ),
      text: "Featured",
    },
    boosted: {
      bg: "bg-purple-500 hover:bg-purple-600",
      icon: <Rocket className={`text-white ${sizeClasses[size].icon}`} />,
      text: "Boosted",
    },
  };

  return (
    <Badge
      className={`${typeProps[type].bg} ${sizeClasses[size].badge} flex items-center gap-1 rounded-full shadow-sm`}
    >
      {typeProps[type].icon}
      {showText && typeProps[type].text}
    </Badge>
  );
}
